module.exports = __webpack_public_path__ + "static/media/qualiss_logo.0de3752c.PNG";